import Swiper, { Pagination, Autoplay, EffectFade, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';
import { toggleAutoplay } from './toggleAutoplay.js';

// Swiperで使用するモジュールを登録
Swiper.use([Pagination, Autoplay, EffectFade, Navigation]);

/**
 * メンバー詳細用Swiper設定
 * - フェードエフェクト
 * - 自動再生
 * - 1枚表示、中央揃え
 */
const memberDetailConfig = {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    speed: 1000,
    autoplay: { delay: 2000 },
    slidesPerView: 1,
    centeredSlides: true,
    breakpoints: {
        // 必要に応じてブレイクポイントを追加
        // 834: { slidesPerView: 3, spaceBetween: 30 },
        // 1024: { slidesPerView: 4, spaceBetween: 40 },
    },
};

/**
 * メンバーリスト用Swiper設定
 * - スライド表示
 * - ループ
 * - ナビゲーション・ページネーション付き
 */
const memberListConfig = {
    loop: true,
    effect: 'slide',
    speed: 1000,
    spaceBetween: 8,
    autoplay: { delay: 2000 },
    slidesPerView: 1.5,
    centeredSlides: true,
    navigation: {
        nextEl: '.js-swiper02_next',
        prevEl: '.js-swiper02_prev',
    },
    pagination: {
        el: ".js-swiper02_pagination",
        type: "fraction",
    },
    breakpoints: {
        834: { slidesPerView: 5 },
        // 1024: { slidesPerView: 4, spaceBetween: 40 },
    },
};

/**
 * Swiperを初期化し、トグル機能を設定する
 */
export default function initSwipers() {
    // スワイパーインスタンス作成
    const swiper1 = new Swiper('.js-swiper01', memberDetailConfig);
    const swiper2 = new Swiper('.js-swiper02', memberListConfig);

    // 各スワイパーに自動再生トグルを適用
    toggleAutoplay('.js-play_toggle01', (event) => {
        if ($(event.currentTarget).hasClass('is-stop')) {
            swiper1.autoplay.stop();
        } else {
            swiper1.autoplay.start();
        }
    });

    toggleAutoplay('.js-play_toggle02', (event) => {
        if ($(event.currentTarget).hasClass('is-stop')) {
            swiper2.autoplay.stop();
        } else {
            swiper2.autoplay.start();
        }
    });
}
